import React, { Component } from "react";
import ChatBot from "react-simple-chatbot";
import { withRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { ChatContainer } from "../../onboarding/OnboardingStyles";
import {
  chatContainerStyleHair,
  chatContentStyle,
  chatbotContentStyleMobileHair,
  chatbotAvatarStyle,
  chatbotAvatarStyleMobile,
  chatbotBubbleStyle,
  chatbotFooterStyle,
  chatbotBubbleStyleMobile,
  helloAvaTheme
} from "../../../utils/styles";
import * as util from "../../../utils/util";
import * as aaUtil from "../../../ath/utils/aaUtils";

import "../../onboarding/Onboarding.css";

class HairOnboarding extends Component {
  constructor(props) {
    super(props);

    this.handleEnd = this.handleEnd.bind(this);

    this.state = {
      viewport: {
        width: document.documentElement.clientWidth,
        height: window.innerHeight
      }
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleMediaQueries.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleMediaQueries.bind(this));
  }

  handleMediaQueries() {
    this.setState({
      viewport: {
        width: document.documentElement.clientWidth,
        height: window.innerHeight
      }
    });
  }

  handleEnd({ steps }) {
    let requestBody = {};

    if (steps["Q0-1"]) {
      setTimeout(() => {
        window.location.href = "/hair/landing";
      }, 1);
      return;
    }

    // The request must contain the 15 survey answers
    if (steps["A4"]) {
      requestBody = {
        Concern: steps["A4"].value.split(":")[0],
        Shape: steps["A4-2"].value,
        Texture: steps["A5"].value,
        Volume: steps["A5-2"].value,
        Dandruff: steps["A6"].value,
        Condition1: steps["A7"].value,
        Condition2: steps["A8"].value,
        Treatment1: steps["A8-1"].value,

        Styling1: steps["A8-3"].value.split(":")[0],
        Styling2: steps["A8-4"].value,
        Styling3: steps["A8-5"].value.split(":")[0],
        Routine: "wash,condition,dry,style,refresh",
        RoutineIdx: "3",
        SelfieIdx: parseInt(steps["A8-6"].value, 10)
      };
    }

    // The request may have a user id if user signin
    if (localStorage.getItem("user_id")) {
      requestBody["userId"] = localStorage.getItem("user_id");
    }

    if (steps["A8-2"]) {
      requestBody["Treatment2"] = steps["A8-2"].value;
    } else {
      requestBody["Treatment2"] = "4";
    }
    // The request may have user selfie if user uploads
    if (steps["A8-6A"]) {
      requestBody["selfie"] = steps["A8-6A"].value;
    }

    // The request may have user profile info if user has not signin
    if (!localStorage.getItem("auth_token")) {
      requestBody["firstName"] = steps["A1-1"].value.split(":")[0];
      requestBody["lastName"] = steps["A1-1"].value.split(":")[1];
      requestBody["age"] = steps["A2"].value;
      // requestBody["ethnicity"] = steps["A3"].value;
      requestBody["gender"] = steps["A3-A"].value;
      if (!localStorage.getItem("user_id") && steps["A9"].value != undefined) {
        if(steps["A9"] && steps["A9"].value ){
          requestBody["email"] = steps["A9"].value.split(":")[0];
          requestBody["phoneNumber"] = steps["A9"].value.split(":")[1];
          requestBody["password"] = steps["A9"].value.split(":")[2];
          requestBody["optIn"] = steps["A9"].value.split(":")[3] === "true";
        }
      }
    }
    if(steps["A9"] && steps["A9"].value && steps["A9"].value != undefined){
      if ((requestBody["optIn"] = steps["A9"].value.split(":")[3] === "true")) {
        aaUtil.event50_opt_in_event("Phase 2");
      }
    }

    if (util.isMobile(navigator.userAgent)) {
      requestBody["signupSource"] = "mobile";
    }

    // Redirect to home if user says 'No' to region question.https://helloavadev.atlassian.net/browse/HD-357
    if (Object.keys(requestBody).length > 0) {
      fetch("/api/hair-profiles", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestBody)
      })
        .then(response => {
          if (localStorage.getItem("auth_token")) {
            localStorage.setItem("user_has_hair_profile", true);
            window.location.href = "/hair/profile";
            // return;
          } else {
            return response.json();
          }
        })
        .then(json => {
          // If this is a new user, we need to save the token and user id
          if (json.token) {
            const firstName = requestBody["firstName"];
            const lastName = requestBody["lastName"];
            const phoneNumber = requestBody["phoneNumber"];
            const email = requestBody["email"];

            localStorage.setItem("auth_token", json.token.token);
            localStorage.setItem("user_id", json.userId);
            localStorage.setItem("user_firstname", firstName);
            localStorage.setItem("user_lastname", lastName);
            localStorage.setItem("phone_number", phoneNumber);
            localStorage.setItem("email", email);
            localStorage.setItem("temp_new_user_flag", true);
          }
          localStorage.setItem("first_from_onboarding", true);
          localStorage.setItem("user_has_hair_profile", true);

          aaUtil.event27_submit_quiz(true);
          window.location.href = "/hair/profile";
        })
        .catch(error => {
          console.log(error);
          // alert("There is a problem to save the survey. Please try again. " + error );
        });
    }
  }

  render() {
    const chatbotStyle = {
      // width: "100%",
      // maxWidth: "1360px",
      // //maxHeight: '100%',
      // height: "100%",
      // //height: (window.innerHeight * 0.925 - window.innerHeight * 2 * 0.032 - 20) + 'px', // 20 is the header logo height
      // //height: this.state.viewport.height - 20,
      // background: "#fff",
      // overflow: "hidden"
    };

    const chatbotStyleMobile = {
      width: "100%",
      maxWidth: "996px",
      //maxHeight: '100%',
      height: "100%",
      //height: (window.innerHeight * 0.925 - window.innerHeight * 2 * 0.032 - 20) + 'px', // 20 is the header logo height
      //height: this.state.viewport.height - 20,
      background: "#fff",
      overflow: "hidden",
      overflowY: "scroll"
    };
    let touchsupport =
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0;

    return (
      <ChatContainer>
        <ThemeProvider theme={helloAvaTheme}>
          <ChatBot
            className={!touchsupport ? "nontouch" : ""}
            hideHeader={true}
            hideUserAvatar={true}
            botAvatar="/images/onboarding/ava-chat.svg"
            steps={this.props.steps}
            handleEnd={this.handleEnd}
            style={chatbotStyle}
            contentStyle={chatContentStyle}
            avatarStyle={
              this.state.viewport.width <= 900
                ? chatbotAvatarStyleMobile
                : chatbotAvatarStyle
            }
            bubbleStyle={
              this.state.viewport.width <= 900
                ? chatbotBubbleStyleMobile
                : chatbotBubbleStyle
            }
            footerStyle={
              chatbotFooterStyle
            } /*enableSmoothScroll={ true } enableMobileAutoFocus={ true }*/
          />
        </ThemeProvider>
      </ChatContainer>
    );
  }
}

export default HairOnboarding;



// WEBPACK FOOTER //
// ./src/views/hair/onboarding/HairOnboarding.js